// extracted by mini-css-extract-plugin
export default {"container":"MR-z","modal":"NR-z","dimensions":"OR-z","brandName":"PR-z","productName":"QR-z","labelValue":"RR-z","recipientEmail":"SR-z","recommendedFit":"TR-z","hiddenField":"UR-z"};